(function () {
  var VID = '44483107553367', QTY = [1, 2, 4];

  /* ---- load layout tweaks (separate file so small edits are cheap) ---- */
  (function () {
    var cs = document.currentScript;
    if (!cs || !cs.src) return;
    var t = document.createElement('script');
    t.src = cs.src.split('?')[0].replace('cushion.js', 'cushion-tweaks.js') + '?v=' + Date.now();
    document.head.appendChild(t);
  })();

  /* ---- remove empty [PAY] placeholder row ---- */
  [].slice.call(document.querySelectorAll('.prc-hero-pay-row')).forEach(function (e) { e.parentNode.removeChild(e); });

  /* ---- selected pack: stronger color ---- */
  (function () {
    var s = document.createElement('style');
    s.textContent = '.prc-root .prc-hero-tier{cursor:pointer;transition:background-color .15s,border-color .15s,box-shadow .15s}' +
      '.prc-root .prc-hero-tier:not(.prc-hero-tier-selected):hover{border-color:#F2A98A !important}' +
      '.prc-root .prc-hero-tier.prc-hero-tier-selected{background-color:#FFE6D9 !important;border-color:#D9480F !important;box-shadow:0 0 0 1px #D9480F,0 6px 18px rgba(217,72,15,.28) !important}' +
      '.prc-root .prc-hero-tier.prc-hero-tier-selected .prc-hero-tier-off{background:#D9480F !important;color:#fff !important}';
    document.head.appendChild(s);
  })();

  /* ---- pack selection ---- */
  var tiers = [].slice.call(document.querySelectorAll('.prc-hero-tier'));
  function pick(i) {
    tiers.forEach(function (t, k) { t.classList.toggle('prc-hero-tier-selected', k === i); });
    [].slice.call(document.querySelectorAll('a[data-js-buy]')).forEach(function (a) {
      a.setAttribute('href', '/cart/' + VID + ':' + QTY[i]);
    });
    var t = tiers[i];
    var p = t.querySelector('.prc-hero-tier-price'), o = t.querySelector('.prc-hero-tier-oldprice');
    var hp = document.querySelector('.prc-hero-price'), ho = document.querySelector('.prc-hero-price-old');
    if (p && hp) hp.textContent = p.textContent;
    if (o && ho) ho.textContent = o.textContent;
    var off = t.querySelector('.prc-hero-tier-off'), pill = document.querySelector('.prc-hero-save-pill');
    if (off && pill) pill.textContent = '🏷 SAVE ' + off.textContent.replace(/\s*OFF/i, '');
  }
  tiers.forEach(function (t, i) {
    t.addEventListener('click', function (e) { e.preventDefault(); pick(i); });
  });
  var sel = 1;
  tiers.forEach(function (t, i) { if (t.classList.contains('prc-hero-tier-selected')) sel = i; });
  if (tiers.length) pick(sel);

  /* ---- accordions (Specifications / Special / Returns) ---- */
  var PANELS = [
    '<ul><li><b>Size:</b> 44 x 42 x 32 cm (about 17.3 x 16.5 x 12.6 in)</li><li><b>Color:</b> All black</li><li><b>Material:</b> Memory foam</li><li><b>Design:</b> One-piece seat and backrest cushion with a hollow center</li><li><b>Use:</b> Office chair, car seat, home seating</li></ul>',
    '<ul><li><b>One-piece design:</b> seat and backrest in a single cushion, so there is nothing to slip out of place.</li><li><b>Memory foam:</b> softly follows the shape of your body.</li><li><b>Hollow center:</b> designed to ease contact pressure when you sit for long periods.</li><li><b>Backrest:</b> adds support for your lower back while you sit.</li></ul>',
    '<p>Not happy with your cushion? Contact us at <a href="mailto:support@easydailys.com">support@easydailys.com</a> within 30 days of delivery and we will help with a return or refund. See our <a href="/policies/refund-policy">Refund policy</a> for the full details.</p>'
  ];
  var st = document.createElement('style');
  st.textContent = '.prc-acc-panel{display:none;margin:-4px 0 10px;padding:14px 18px;border:1px solid rgba(0,0,0,.08);border-top:0;border-radius:0 0 12px 12px;font-family:Inter,Arial,Helvetica,sans-serif;font-size:14px;line-height:1.55;color:#1F2430;background:#fff}.prc-acc-panel ul{margin:0;padding-left:18px}.prc-acc-panel li{margin:4px 0}.prc-acc-panel p{margin:0}.prc-acc-panel a{color:#D9480F;text-decoration:underline}.prc-acc-panel.open{display:block}.prc-hero-accordion{cursor:pointer}.prc-hero-accordion-chev{transition:transform .2s}.prc-hero-accordion.open .prc-hero-accordion-chev{transform:rotate(90deg)}';
  document.head.appendChild(st);
  [].slice.call(document.querySelectorAll('.prc-hero-accordion')).forEach(function (row, i) {
    if (!PANELS[i]) return;
    var panel = document.createElement('div');
    panel.className = 'prc-acc-panel';
    panel.innerHTML = PANELS[i];
    row.parentNode.insertBefore(panel, row.nextSibling);
    row.addEventListener('click', function () {
      var open = !panel.classList.contains('open');
      panel.classList.toggle('open', open);
      row.classList.toggle('open', open);
    });
  });
})();
